
// Total bill ------ /orders

import React, { useEffect, useState } from 'react';
import { actions } from '../store/actions';
import { components } from '../components';
import settingsWhite from '../assets/images/settings-white.png';
import { FiPlus, FiMinus } from 'react-icons/fi';
import { hooks } from '../hooks';
import { BeatLoader, PropagateLoader } from 'react-spinners'
import dayjs from 'dayjs';
import { getCollection } from '../services';
import { getDocs, query, where, collection, doc, runTransaction, Timestamp, getDoc, updateDoc, addDoc } from 'firebase/firestore'

import { db } from '../configs/firebaseConfig';

import { useNavigate } from 'react-router-dom'


interface Cart {
  id: number | string;
  name: string;
  full_price: string;
  half_price: string;
  quarter_price: string;
  quantity: number;
  portion: string;
  is_full_portion: string;
  is_half_portion: string;
  is_quarter_portion: string;
  estimated_time: string;
  veg_type: string;
  images: string[];
  // category: string;
  // subCategory: string;
  type: string;
}

type FilteredCartItem = {
  // category: string;
  estimated_time: string;
  price: string;
  id: string | number;
  images: string[];
  name: string;
  portion: string;
  quantity: number;
  // subCategory: string;
  type: string;
  veg_type: string;
};

interface WaiterType {
  id: string
  name: string
}

interface PlatformFeeTransaction {
  restaurantId: string;
  tableId: string;
  orderId: string;
  platformFeeAmount: number;
}

interface PlatformFee {
  value: string;
  currency: string;
};

interface OrderParams {
  restaurantId: string
  qrId: string
  qrNumber: string
  qrType: string
  items: FilteredCartItem[];
  subTotal: number
  taxName: string
  taxValue: number
  grandTotal: number
  instructions: string
  paymentStatus: number
  orderStatus: number
  createdAt: Timestamp
  transactionId?: string
  currencySymbol?: string | null
  currency?: {
    name: string
    symbol: string
    value: string
  } | null
  customer?: {
    firstName: string
    lastName: string
  }
  waiter?: WaiterType
  waiterId?: string
}

export const OrderHistory: React.FC = () => {

  const dispatch = hooks.useDispatch();
  const [cart, setCart] = useState<Cart[]>([]);
  const [value, setValue] = useState<string>('')
  const [subTotal, setSubTotal] = useState(0)
  const [grandTotal, setGrandTotal] = useState(0)

  const [taxType, setTaxType] = useState<string>('')
  const [taxPercentage, setTaxPercentage] = useState<number>(0)
  const [configCurrency, setConfigCurrency] = useState<{ name?: string; symbol?: string; value?: string } | null>(null)
  const [currencySymbol, setCurrencySymbol] = useState<string | null>(null)
  const [currency, setCurrency] = useState<string | null>(null)
  const [walletBalance, setWalletBalance] = useState<number | null>(null);
  const [platformFee, setPlatformFee] = useState<PlatformFee | null>(null);
  const [currencyObj, setCurrencyObj] = useState<{
    name: string
    symbol: string
    value: string
  } | null>(null)


  const [calculatedTax, setCalculatedTax] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPortion, setSelectedPortion] = useState<string>('full')

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [waiter, setWaiter] = useState<WaiterType | null>(null)
  const [taxName, setTaxName] = useState('');
  const [taxValue, setTaxValue] = useState(0);


  const handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFirstName(e.target.value)
  }

  const handleLastNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLastName(e.target.value)
  }

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(event.target.value)
  }

  hooks.useThemeColor('#fff');

  const nav = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(actions.setColor('#fff'));
  }, []);


  useEffect(() => {
    getCollection("configurations")
      .then(
        (data: { id: string; currency?: { symbol?: string }; platformFee?: { value?: string; currency?: string } }[]) => {
          if (data?.length > 0) {
            const currencyConfig = data.find((item) => item.currency?.symbol);
            if (currencyConfig?.currency?.symbol) {
              setCurrencySymbol(currencyConfig.currency.symbol);
            } else {
              setCurrencySymbol(null);
            }

            const feeConfig = data.find((item) => item.platformFee?.value && item.platformFee?.currency);
            if (feeConfig?.platformFee) {
              const { value, currency } = feeConfig.platformFee;

              if (typeof value === 'string' && typeof currency === 'string') {
                setPlatformFee({ value, currency });
                // console.log("fee:", feeConfig?.platformFee)
              } else {
                setPlatformFee(null);
              }
            } else {
              setCurrencySymbol(null);
              setPlatformFee(null);
            }
          }
        }
      ).catch((error) => {
        console.error("Error fetching configurations:", error);
        setCurrencySymbol(null);
        setPlatformFee(null);
      });
  }, []);

  const tableData = localStorage.getItem('table');
  const table = tableData ? JSON.parse(tableData) : null;

  const calculatePrice = (item: any) => {
    let price = 0

    if (item.portion === "quarter" && item.is_quarter_portion) {
      price = Number(item.quarter_price) * Number(item.quantity)
    } else if (item.portion === "half" && item.is_half_portion) {
      price = Number(item.half_price) * Number(item.quantity)
    } else if (item.portion === "full" && item.is_full_portion) {
      price = Number(item.full_price) * Number(item.quantity)
    }

    return isNaN(price) ? "0.00" : price.toFixed(2)
  }

  const handleItemCountChange = (item: any, action: 'increment' | 'decrement') => {
    if (item && action) {
      setCart((prevData: any) => {
        const existingIndex = prevData.findIndex((obj: any) => obj.id === item.id);
        let updatedCart = [];

        if (existingIndex !== -1) {
          updatedCart = prevData.map((cartItem: any, index: number) => {
            if (index === existingIndex) {
              const updatedQuantity = (action === 'increment')
                ? cartItem.quantity + 1
                : (action === 'decrement')
                  ? cartItem.quantity - 1
                  : cartItem.quantity;

              return updatedQuantity > 0 ? { ...cartItem, quantity: updatedQuantity } : null;
            }
            return cartItem;
          }).filter((cartItem: any) => cartItem !== null);
        } else {
          let portion = 'full';

          if (item.is_full_portion && item.full_price) {
            portion = 'full';
          } else if (item.is_half_portion && item.half_price) {
            portion = 'half';
          } else if (item.is_quarter_portion && item.quarter_price) {
            portion = 'quarter';
          }

          updatedCart = [
            ...prevData,
            {
              id: item?.id,
              name: item?.name,
              full_price: item?.full_price,
              is_full_portion: item?.is_full_portion,
              half_price: item?.half_price,
              is_half_portion: item?.is_half_portion,
              quarter_price: item?.quarter_price,
              is_quarter_portion: item?.is_quarter_portion,
              portion: portion,
              estimated_time: item?.estimated_time,
              veg_type: item?.veg_type,
              // category: item?.category,
              // subCategory: item?.subCategory,
              type: item?.type,
              images: item?.images,
              quantity: 1,
            },
          ];
        }

        // Save the updated cart data to localStorage
        localStorage.setItem('cart', JSON.stringify(updatedCart));

        return updatedCart;
      });
    }
  };

  useEffect(() => {
    const storedCart = localStorage.getItem('cart');
    if (storedCart) {
      try {
        setCart(JSON.parse(storedCart));
        // console.log("cart:", JSON.parse(storedCart))
      } catch (err) {
        console.error("Invalid cart data in localStorage", err);
        setCart([]);
      }
    } else {
      setCart([]);
    }
  }, []);

  useEffect(() => {
    const sum = cart.reduce((accumulator, current) => {

      let price = 0;

      if (current.is_full_portion && current.portion === 'full') {
        price = Number(current.full_price);
      } else if (current.is_half_portion && current.portion === 'half') {
        price = Number(current.half_price);
      } else if (current.is_quarter_portion && current.portion === 'quarter') {
        price = Number(current.quarter_price);
      }

      const validPrice = isNaN(price) ? 0 : price;
      return accumulator + validPrice * Number(current.quantity);
    }, 0);

    const calculatedSubTotal = sum > 0 ? sum : 0;
    setSubTotal(calculatedSubTotal);

    const calculatedTax = calculatedSubTotal * (taxValue / 100)
    setCalculatedTax(calculatedTax);

    const calculatedGrandTotal = calculatedSubTotal + calculatedTax;
    setGrandTotal(calculatedGrandTotal);

  }, [cart, taxValue]);

  useEffect(() => {
    if (cart?.length > 0) {
      const estimatedTimes = cart
        .map(item => parseInt(item.estimated_time, 10))
        .filter(time => !isNaN(time))

      if (estimatedTimes.length > 0) {
        let finalTime = 0

        if (cart.length === 1) {
          finalTime = estimatedTimes[0]
        } else {
          const total = estimatedTimes.reduce((acc, time) => acc + time, 0)
          finalTime = Math.round(total / estimatedTimes.length)
        }

        localStorage.setItem('estimated_time', finalTime.toString())
        // console.log(' estimated_time:', finalTime)
      }
    }
  }, [cart])

  useEffect(() => {
    const fetchWaiter = async () => {
      const tableData = localStorage.getItem('table')
      const table = tableData ? JSON.parse(tableData) : null
      // console.log("table data:", table)

      if (!table?.id || !table?.restaurantId) {
        console.log('Table ID or Restaurant ID is missing.')
        return
      }

      try {
        const waiterSnapshot = await getDocs(
          query(collection(db, 'waiters'), where('table', '==', table.id))
        )

        if (!waiterSnapshot.empty) {
          waiterSnapshot.forEach(doc => {
            const data = doc.data() as { name: string }
            const waiterData: WaiterType = {
              id: doc.id,
              name: data.name,
            }
            setWaiter(waiterData)
          })
        } else {
          const restaurantWaitersSnapshot = await getDocs(
            query(collection(db, 'waiters'), where('restaurantId', '==', table.restaurantId))
          )

          const waiterList: WaiterType[] = []
          restaurantWaitersSnapshot.forEach(doc => {
            const data = doc.data() as { name: string }
            const waiter = {
              id: doc.id,
              name: data.name,
            }
            waiterList.push(waiter)
          })

          if (waiterList.length > 0) {
            const randomIndex = Math.floor(Math.random() * waiterList.length)
            setWaiter(waiterList[randomIndex])
          } else {
            console.log('No waiters found for this restaurant.')
          }
        }
      } catch (err) {
        console.error('Error fetching waiter:', err)
      }
    }

    fetchWaiter()
  }, [])

  useEffect(() => {
    const restaurant = localStorage.getItem('restaurant');
    const res = restaurant ? JSON.parse(restaurant) : null;

    if (res?.currency) {
      setCurrencyObj(res.currency);
      setCurrency(res.currency.symbol);
    } else {
      setCurrencyObj(null);
      setCurrency('');
    }

    if (res?.taxName) {
      setTaxName(res.taxName);
    }
    if (res?.taxValue) {
      setTaxValue(Number(res.taxValue));
    }

    if (typeof res?.walletBalance === 'number') {
      setWalletBalance(res.walletBalance)
      // console.log("balance:", res.walletBalance)
    } else {
      setWalletBalance(null)
    }
  }, []);

  const addPlatformFeeTransaction = async ({ restaurantId, tableId, orderId, platformFeeAmount,
  }: PlatformFeeTransaction) => {
    try {
      const platformFeeTransactionRef = collection(db, 'platform_fee_transaction');

      const data = {
        restaurantId,
        tableId,
        orderId,
        platformFeeAmount,
        createdAt: Timestamp.now(),
      };

      const docRef = await addDoc(platformFeeTransactionRef, data);

    } catch (error) {
      console.error(" Failed to add platform fee transaction:", error);
    }
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      const restaurant = localStorage.getItem('restaurant');
      const res = restaurant ? JSON.parse(restaurant) : null;

      const tableData = localStorage.getItem('table');
      const table = tableData ? JSON.parse(tableData) : null;

      if (!res?.id || !table?.id || !table?.number || !table?.type) {
        console.error("Restaurant or Table (QR) information is missing");
        setIsLoading(false);
        return;
      }

      const filteredCart: FilteredCartItem[] = cart.map(item => {
        let price = '';
        if (item.portion === 'full' && item.is_full_portion) price = item.full_price;
        else if (item.portion === 'half' && item.is_half_portion) price = item.half_price;
        else if (item.portion === 'quarter' && item.is_quarter_portion) price = item.quarter_price;

        return {
          estimated_time: item.estimated_time,
          price: price,
          id: item.id,
          images: item.images,
          name: item.name,
          portion: item.portion,
          quantity: item.quantity,
          type: item.type,
          veg_type: item.veg_type,
        };
      });

      const ordersRef = collection(db, 'orders');
      const q = query(
        ordersRef,
        where('restaurantId', '==', res.id),
        where('qrId', '==', table.id),
        where('orderStatus', '==', 0)
      );
      const querySnapshot = await getDocs(q);

      const shouldCreateNewOrder = querySnapshot.empty;
      const existingOrderDoc = !shouldCreateNewOrder ? querySnapshot.docs[0] : null;
      const existingOrderDocRef = existingOrderDoc ? doc(db, 'orders', existingOrderDoc.id) : null;
      const existingOrderData = existingOrderDoc?.data() as OrderParams | null;

      let orderId: string | null = null;

      if (!shouldCreateNewOrder && existingOrderDocRef && existingOrderData) {
        const existingItems = existingOrderData.items || [];

        const updatedItems = [...existingItems];
        filteredCart.forEach(newItem => {
          const matchIndex = updatedItems.findIndex(
            item =>
              item.id === newItem.id &&
              item.portion === newItem.portion &&
              item.price === newItem.price
          );

          if (matchIndex > -1) {
            updatedItems[matchIndex].quantity += newItem.quantity;
          } else {
            updatedItems.push(newItem);
          }
        });

        const updatedSubTotal = existingOrderData.subTotal + subTotal;
        const updatedGrandTotal = existingOrderData.grandTotal + grandTotal;

        await updateDoc(existingOrderDocRef, {
          items: updatedItems,
          subTotal: updatedSubTotal,
          grandTotal: updatedGrandTotal,
          instructions: value
        });

        orderId = existingOrderDocRef.id;

      } else {

        const fee = platformFee?.value ? parseFloat(platformFee.value) : 0;
        const currentBalance = typeof walletBalance === 'number' ? walletBalance : 0;

        if (fee > currentBalance) {
          console.log("Insufficient wallet balance to cover the platform fee.");
          setIsLoading(false);
          return;
        }

        const newWalletBalance = currentBalance - fee;

        const restaurantRef = doc(db, 'restaurants', res.id);
        await updateDoc(restaurantRef, { walletBalance: newWalletBalance });

        const updatedRes = { ...res, walletBalance: newWalletBalance };
        localStorage.setItem('restaurant', JSON.stringify(updatedRes));
        setWalletBalance(newWalletBalance);

        const collectionRef = collection(db, 'orders');
        const newDocRef = doc(collectionRef);

        const params: OrderParams = {
          restaurantId: res.id,
          qrId: table.id,
          qrNumber: table.number,
          qrType: table.type,
          items: filteredCart,
          subTotal,
          taxName,
          taxValue,
          grandTotal,
          instructions: value,
          orderStatus: 0,
          paymentStatus: 0,
          createdAt: Timestamp.now(),
          transactionId: newDocRef.id,
          currency: currencyObj,
          currencySymbol: currency,
          customer: {
            firstName,
            lastName
          },
          ...(waiter && {
            waiter,
            waiterId: waiter.id
          })
        };

        const counterRef = doc(db, "counters", "orders");
        const existingOrders = localStorage.getItem('orders');
        let orders = existingOrders ? JSON.parse(existingOrders) : {};

        if (orders[table.id]) {
          orders[table.id].push(newDocRef.id);
        } else {
          orders[table.id] = [newDocRef.id];
        }

        localStorage.setItem('orders', JSON.stringify(orders));
        localStorage.setItem('orderId', newDocRef.id);

        await runTransaction(db, async (transaction) => {
          const counterDoc = await transaction.get(counterRef);
          let newOrderNumber = 1;

          if (counterDoc.exists()) {
            newOrderNumber = counterDoc.data().latestOrderNumber + 1;
          }

          transaction.set(counterRef, { latestOrderNumber: newOrderNumber });
          transaction.set(newDocRef, { ...params, orderNumber: newOrderNumber });
        });

        orderId = newDocRef.id;

        await addPlatformFeeTransaction({
          restaurantId: res.id,
          tableId: table.id,
          orderId,
          platformFeeAmount: fee,
        });

        console.log('Order created successfully:', params);
      }

      localStorage.removeItem('cart');

      if (orderId) {
        nav(`/order-successful/${orderId}`);
      } else {
        nav('/order-successful');
      }

    } catch (error) {
      console.log('Error submitting order:', error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleNavigation = () => {
    const token = localStorage.getItem('token');
    if (token) {
      nav(`/${token}`)
    }
  }

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showBurger={true}
        showButton={true}
        headerStyle={{
          backgroundColor: 'transparent',
        }}
      />
    );
  };

  const renderContent = (): JSX.Element => {

    const smallScreen = window.innerWidth === 320 && window.innerHeight === 568;

    return (
      <main style={{ backgroundColor: '#f2f4f4' }}>
        <div
          style={{
            backgroundPosition: 'center',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 15,
          }}
        >
          {cart && cart.length > 0 ? (
            <>
              <div
                className="container"
                style={{
                  borderRadius: '10px',
                  padding: '10px',
                  // marginTop: '20px',
                  marginBottom: '20px',
                  boxShadow: '0px 4px 4px rgba(128, 128, 128, 0.2), 0px -4px 4px rgba(128, 128, 128, 0.2), 4px 0px 4px rgba(128, 128, 128, 0.2), -4px 0px 4px rgba(128, 128, 128, 0.2)',
                  backgroundColor: '#fff',
                }}
              >
                {isLoading ? (
                  <div style={{ marginBlock: '2rem', textAlign: 'center' }}>
                    <BeatLoader />
                  </div>
                ) : (
                  cart.map(item => (

                    <div
                      key={item.id}
                      style={{
                        display: 'grid',
                        gridTemplateColumns: ' 3fr 3fr 2fr',
                        alignItems: 'center',
                        gap: smallScreen ? '8px' : '15px',
                        padding: smallScreen ? '4px' : '10px',
                      }}
                    >
                      {/* <img
                        src={settingsWhite}
                        alt="settingsWhite"
                        style={{
                          maxWidth: '100%',
                          height: 'auto',
                          justifySelf: 'center',
                        }}
                      />
                       */}
                      <p
                        style={{
                          textAlign: 'left',
                          margin: 0,
                          textTransform: 'capitalize',
                          fontFamily: 'Poppins',
                          fontSize: smallScreen ? '11px' : '12px',
                        }}
                      >
                        {item.name}
                      </p>

                      <div
                        style={{
                          padding: '8px 13px',
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          backgroundColor: '#252525',
                          width: '100%',
                        }}
                      >
                        <button onClick={() => handleItemCountChange(item, 'decrement')}>
                          <FiMinus color="#fff" size={18} />
                        </button>
                        <span
                          style={{
                            fontSize: '14px',
                            color: 'white',
                            fontFamily: 'Poppins',
                          }}
                        >
                          {item.quantity}
                        </span>
                        <button onClick={() => handleItemCountChange(item, 'increment')}>
                          <FiPlus color="#fff" size={18} />
                        </button>
                      </div>

                      <p
                        style={{
                          margin: 0,
                          textTransform: 'capitalize',
                          fontFamily: 'Poppins',
                          fontSize: smallScreen ? '12px' : '14px',
                          textAlign: 'center',
                        }}
                      >
                        {currency ? currency : currencySymbol}{calculatePrice(item)}
                      </p>
                    </div>
                  ))
                )}
              </div>


              <div style={{
                marginBottom: '5%',
                borderRadius: '10px',
                padding: '10px',
                boxShadow: '0px 4px 4px rgba(128, 128, 128, 0.2), 0px -4px 4px rgba(128, 128, 128, 0.2), 4px 0px 4px rgba(128, 128, 128, 0.2), -4px 0px 4px rgba(128, 128, 128, 0.2)',
                width: "100%",
                backgroundColor: '#fff'
              }}>
                <h4
                  style={{
                    textAlign: 'left',
                    marginBottom: 12,
                    marginTop: "4%",
                    fontFamily: "Poppins",
                    fontSize: smallScreen ? '12px' : "14px",
                    fontWeight: 500
                  }}
                >
                  Customer
                </h4>

                <div style={{
                  display: 'flex',
                  flexDirection: smallScreen ? 'column' : 'row',
                  gap: '10px',
                  flexWrap: 'wrap',
                  width: '100%'
                }}>
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    value={firstName}
                    onChange={handleFirstNameChange}
                    style={{
                      width: smallScreen ? '100%' : '48%',
                      padding: '10px',
                      fontSize: smallScreen ? '13px' : "14px",
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      fontFamily: 'Poppins'
                    }}
                  />

                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={handleLastNameChange}
                    style={{
                      width: smallScreen ? '100%' : '48%',
                      padding: '10px',
                      fontSize: smallScreen ? '13px' : "14px",
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      fontFamily: 'Poppins'
                    }}
                  />
                </div>
              </div>

              <div style={{
                borderRadius: '10px',
                padding: '10px',
                boxShadow: '0px 4px 4px rgba(128, 128, 128, 0.2), 0px -4px 4px rgba(128, 128, 128, 0.2), 4px 0px 4px rgba(128, 128, 128, 0.2), -4px 0px 4px rgba(128, 128, 128, 0.2)', width: "100%",
                backgroundColor: '#fff'
              }}
              >
                <h4
                  style={{
                    textAlign: 'left',
                    marginBottom: 12,
                    marginTop: "4%",
                    fontFamily: "Poppins",
                    fontSize: smallScreen ? '12px' : "14px",
                    fontWeight: 500
                  }}
                >
                  Add Instructions
                </h4>

                <div style={{ position: 'relative', width: '100%' }}>

                  <textarea
                    id="instructions"
                    name="instructions"
                    rows={4}
                    cols={40}
                    value={value}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      padding: '10px',
                      fontSize: smallScreen ? '13px' : "14px",
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      resize: 'vertical',
                      whiteSpace: 'pre-wrap',
                    }}
                  ></textarea>

                  {!value && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                        pointerEvents: 'none',
                        fontSize: smallScreen ? '11px' : "12px",
                        fontFamily: "Poppins",
                        color: '#999',
                      }}
                    >
                      Enter if you have any Personal Preferences
                      <br />
                      <span style={{ fontSize: '10px', fontStyle: 'italic', fontFamily: "Poppins" }}>
                        Ex: Please Add Low Sodium Salt in my food
                      </span>
                    </div>
                  )}
                </div>

              </div>

              <div style={{
                marginTop: '5%', marginBottom: '10%', borderRadius: 10, border: "1px solid #dedede", padding: "10px", boxShadow: '0px 4px 4px rgba(128, 128, 128, 0.2), 0px -4px 4px rgba(128, 128, 128, 0.2), 4px 0px 4px rgba(128, 128, 128, 0.2), -4px 0px 4px rgba(128, 128, 128, 0.2)', width: "100%",
                backgroundColor: '#fff'

              }}>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <h4 style={{
                    textAlign: 'left', marginLeft: 10, marginTop: 10, fontSize: smallScreen ? '12px' : '15px', fontWeight: 500
                  }}>
                    Total Bill - {table ? `${table.type} ${table.number}` : ""}

                  </h4>
                  <small style={{ marginLeft: 10, fontFamily: "Poppins", fontSize: smallScreen ? "10px" : "11px", marginTop: 10 }}>{dayjs().format('dddd, DD MMM YYYY')}</small>

                </div>

                <div
                  className=' row-center-space-between'
                  style={{ marginTop: 10 }}
                >
                  <span
                    style={{
                      fontSize: smallScreen ? '11px' : '13px',
                      fontFamily: 'Poppins',
                      paddingInline: 10

                    }}
                  >
                    Sub Total Bill
                  </span>
                  <div style={{ marginRight: 10, display: 'flex', gap: 20, fontFamily: "Poppins", fontSize: smallScreen ? '12px' : '14px' }}>
                    <span> {currency ? currency : currencySymbol} {Number(subTotal).toFixed(2)}</span>
                  </div>
                </div>


                {taxValue > 0 && (
                  <div className='row-center-space-between' style={{ marginTop: 10 }}>
                    <span
                      style={{
                        fontSize: smallScreen ? '11px' : '13px',
                        fontFamily: 'Poppins',
                        paddingInline: 10
                      }}
                    >
                      {`${taxValue}% ${taxName}`}
                    </span>

                    <div style={{ marginRight: 10, display: 'flex', gap: 20, fontFamily: "Poppins", fontSize: smallScreen ? '12px' : '14px' }}>
                      <span>{currency ? currency : currencySymbol} {Number(calculatedTax).toFixed(2)}</span>
                    </div>
                  </div>
                )}


                <div style={{ marginBottom: 15 }}>
                  <div
                    className=' row-center-space-between'
                    style={{ marginTop: 10 }}
                  ><span
                    style={{
                      fontSize: smallScreen ? '11px' : '13px',
                      fontFamily: 'Poppins',
                      fontWeight: 700,
                      paddingInline: 10
                    }}
                  >
                      Grand Total
                    </span>

                    <div style={{ marginRight: 10, display: 'flex', gap: 20, fontWeight: 700, fontFamily: "Poppins", fontSize: smallScreen ? '12px' : '14px' }}>
                      <span> {currency ? currency : currencySymbol} {Number(grandTotal).toFixed(2)}</span>

                    </div>
                  </div>
                </div>
              </div>

              <div className='container' style={{ paddingLeft: 0, paddingRight: 0 }}>
                <div
                  style={{
                    gap: 15,
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    marginBottom: "10%"
                  }}
                >

                  <components.Button
                    text={isLoading ? 'Placing Order...' : 'Place Order'}
                    variant='inverse'
                    onClick={handleSubmit}
                    disabled={isLoading}
                  />

                  <components.Button
                    text='Add More Dishes'
                    colorScheme='primary'
                    // to='/shop'
                    onClick={handleNavigation}
                    disabled={isLoading}
                  />
                </div>
              </div>

            </>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '90vh'
              }}
            >
              <div
                style={{
                  textAlign: 'center',
                  padding: '20px',
                  borderRadius: '10px',
                  backgroundColor: '#fff',
                  boxShadow: '0px 4px 4px rgba(128, 128, 128, 0.2)',

                }}
              >
                <h3
                  style={{
                    fontFamily: 'Poppins',
                    fontSize: '18px',
                    fontWeight: 800,
                    color: '#000',
                    marginTop: 10
                  }}
                >
                  Your cart is empty
                </h3>
                <p
                  style={{
                    fontFamily: 'Poppins',
                    fontSize: '13px',
                    marginTop: 15,
                    fontWeight: 400,
                  }}
                >
                  Please add some items to your cart to place an order.
                </p>

                <div style={{ marginTop: 50, marginBottom: 10 }}>
                  <components.Button
                    text='Add More Dishes'
                    variant="inverse"
                    // to='/shop'
                    onClick={handleNavigation}
                  />
                </div>

              </div>
            </div>

          )}
        </div>

      </main>
    );
  };


  return (
    <>
      {renderHeader()}
      {renderContent()}

    </>
  );
};

